import { lazy, ComponentType } from 'react';

const KEY = 'emerge.chunkReload';

/**
 * React.lazy that survives a release. A tab opened before a deploy still names the previous build's chunks, which are
 * gone afterwards, so its first visit to a lazy page fails to load. On that first failure the page reloads once
 * (index.html is served no-store, so the reload names the new build); a second failure in the same tab is thrown to
 * the ErrorBoundary as before. Without storage there is no reload, so it can never loop.
 */
export function lazyWithReload<T extends ComponentType<any>>(load: () => Promise<{ default: T }>) {
  return lazy(async () => {
    try {
      const m = await load();
      try { sessionStorage.removeItem(KEY); } catch { /* storage unavailable */ }
      return m;
    } catch (err) {
      let reloaded = true;
      try { reloaded = sessionStorage.getItem(KEY) === '1'; sessionStorage.setItem(KEY, '1'); } catch { /* storage unavailable */ }
      if (reloaded) throw err;
      window.location.reload();
      return new Promise<{ default: T }>(() => undefined);
    }
  });
}
